(ns storrito.connect3.waiting
  (:require
    [storrito.connect3.info-panel :as info-panel]
    [storrito.ui.spinner :as spinner]))

(defn progress-bar
  [progress]
  [:div.w-full.max-w-md
   [:div.flex.justify-center.items-center.mb-2
    [:span.text-sm.font-medium.text-gray-500
     (if (number? progress)
       (str (int progress) "%")
       "Connecting...")]]
   [:div.w-full.bg-gray-200.rounded-full.h-3.overflow-hidden
    (if (number? progress)
      [:div.h-3.bg-secondary-500.rounded-full
       {:style {:width "0%"
                :animation (str "progress-to-" progress " 1s ease-out forwards")}}]
      [:div.h-3.bg-secondary-500.rounded-full.animate-pulse
       {:style {:width "100%"
                :animation "progress-indeterminate 2s ease-in-out infinite"}}])]])

(defn get-message-and-progress
  [state]
  (let [last-request (->> (:events state)
                          (filter #(= (:event/kind %) "connect3/request"))
                          last)]
    (case (get-in last-request [:data :status])
    "login-data"
    {:message "Sending Login Data"
     :subtitle "Securely connecting to your Instagram account, this may take up to 3 minutes."
     :progress 25}
    
    "select-2fa-method"
    (case (:2fa-verification-method state)
      "notification"
      {:message "Verify New Device"
       :subtitle "Please verify the new device in your Instagram App"
       :progress 50}

      "backup_codes"
      {:message "Verify New Device"
       :subtitle "Verify new Device with Backup Codes"
       :progress 50}

      "auto-totp"
      {:message "Verify New Device"
       :subtitle "Verify new Device with Storrito Authentication"
       :progress 50}
      
      {:message "Sending 2FA Code"
       :subtitle (str "Sending verification code to " (:2fa-verification-method state))
       :progress 50})

    "two-factor-code-required"
    {:message "Verify 2FA Code"
     :subtitle "Verifying your authentication code"
     :progress 75}

    "two-factor-notification-required"
    {:message "Checking Your Approval"
     :subtitle "Asking Instagram whether the login request was approved"
     :progress 75}
    
    {:message  "Connecting to Instagram"
     :subtitle "This usually takes a few seconds up to three minutes. Please don't close this window."
     :progress nil})))

(defn panel
  [state]
  (let [{:keys [message subtitle progress]} (get-message-and-progress state)]
    [:div.flex.items-center.justify-center.px-4
     [:div.max-w-md.w-full.bg-white.rounded-xl.shadow-lg.p-8.text-center
      
      ;; CSS for progress animations
      [:style
       "@keyframes progress-indeterminate {
         0% { transform: translateX(-100%); }
         50% { transform: translateX(0%); }
         100% { transform: translateX(100%); }
       }
       @keyframes progress-to-25 {
         0% { width: 0%; }
         100% { width: 25%; }
       }
       @keyframes progress-to-50 {
         0% { width: 0%; }
         100% { width: 50%; }
       }
       @keyframes progress-to-75 {
         0% { width: 0%; }
         100% { width: 75%; }
       }"]
      
      ;; Spinner
      [:div.mb-6
       (spinner/primary-spinner)]
      
      ;; Main message
      [:h2.text-xl.font-semibold.text-gray-900.mb-2
       message]

      ;; Subtitle
      [:p.text-gray-600.mb-8
       subtitle]

      ;; Progress bar
      [:div.mb-6
       (progress-bar progress)]

      ;; Helpful tip (rotates every 10s, driven by poll re-renders)
      (when-not (:connect-link state)
        (let [idx (mod (quot (.now js/Date) 10000) (count info-panel/tips))
              {:keys [content]} (nth info-panel/tips idx)]
          (into [:i.text-sm.text-gray-700] content)))]
     ]))
